module.exports = __webpack_public_path__ + "img/facility-25.bc9ab5fc.svg";